module.exports = __webpack_public_path__ + "img/ccm.e04889d7.png";